import Cookies from 'js-cookie';
import { jwtDecode, JwtPayload } from 'jwt-decode';

interface DecodedToken extends JwtPayload {
  exp: number;
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const now = Math.floor(Date.now() / 1000);
    return decoded.exp < now;
  } catch (error) {
    console.error('Failed to decode JWT token', error);
    return true; // Treat token as expired in case of an error
  }
};

export const decodeJwtToken = (token: string): object => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return { decoded };
  } catch (error) {
    console.error('Failed to decode JWT token', error);
    return {};
  }
};

export const setTokens = (authToken: string, refreshToken: string) => {
  Cookies.set('authToken', authToken, { secure: true, expires: 7 });
  Cookies.set('refreshToken', refreshToken, { secure: true, expires: 7 });
};
